<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="practica" titulo="Práctica / Coordinación académica" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('carreras_planes', 'carrera-plan', 'filtrar');"></a>
                    <a id="filtrar" (click)="filtrar();"></a>


                    <div class="columns">
                        <div class="field column is-6">
                            <label for="nombre">Nombre de la práctica</label>
                            <p class="control is-expanded has-icon has-icon-right">
                                <input class="input" formControlName="nombre" title="Nombre de práctica" placeholder="Escribe el nombre de la práctica" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required')}" />

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>

                        <div class="field column is-3">
                            <label for="nivel">Nivel de la práctica</label>
                            <p class="control is-expanded has-icon has-icon-right">
                                <input class="input" formControlName="nivel" title="Nivel de la práctica" placeholder="Nivel de práctica: Ej. 1" type="number" [ngClass]="{'is-danger': ctrl.dato.get('nivel').hasError('required')}" />

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nivel').hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nivel').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>

                        <div class="field column is-3">
                            <label for="porcentaje_valor">Porcentaje de la práctica</label>
                            <p class="control is-expanded has-icon has-icon-right">
                                <input class="input" formControlName="porcentaje_valor" title="Porcentaje de la práctica" placeholder="Porcentaje de práctica: Ej. 1" type="number" [ngClass]="{'is-danger': ctrl.dato.get('porcentaje_valor').hasError('required')}" />

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('porcentaje_valor').hasError('required') ">
                              <i class="fa fa-warning"></i>
                            </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('porcentaje_valor').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column b-checkbox is-info text-success">
                            <input id="causa_reprobacion" name="causa_reprobacion" [checked]="ctrl.dato.get('causa_reprobacion').value == 1 ? true : false" (change)="ctrl.dato.get('causa_reprobacion').patchValue(ctrl.dato.get('causa_reprobacion').value == 1 ? 0 : 1)" class="styled"
                                type="checkbox">
                            <label for="causa_reprobacion"> Causa reprobación
                          </label>
                        </div>

                        <div class="column b-checkbox is-info text-success">
                            <input id="imprimible_boleta" name="imprimible_boleta" [checked]="ctrl.dato.get('imprimible_boleta').value == 1 ? true : false" (change)="ctrl.dato.get('imprimible_boleta').patchValue(ctrl.dato.get('imprimible_boleta').value == 1 ? 0 : 1)" class="styled"
                                type="checkbox">
                            <label for="imprimible_boleta"> Imprimible en boleta
                          </label>
                        </div>

                        <div class="column b-checkbox is-info text-success">
                            <input id="imprimible_alumno" name="imprimible_alumno" [checked]="ctrl.dato.get('imprimible_alumno').value == 1 ? true : false" (change)="ctrl.dato.get('imprimible_alumno').patchValue(ctrl.dato.get('imprimible_alumno').value == 1 ? 0 : 1)" class="styled"
                                type="checkbox">
                            <label for="imprimible_alumno"> Imprimible en el módulo del alumno
                          </label>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column is-5">
                            <label for="carreras_planes_id">Carrera Plan</label>
                            <div class="select">
                                <select class="select" name="carreras_planes_id" (change)="filtrar();" [ngClass]="{'is-danger': ctrl.dato.get('carreras_planes_id').hasError('required') }" formControlName="carreras_planes_id">
                                  <option *ngFor="let item of ctrl.carreras_planes;" value="{{item.id}}">{{item.planes_estudios.nombre}} / {{item.carreras.nombre}}</option>
                                </select>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required') ">Este campo es requerido.</span>
                            </div>
                        </div>
                        <div class="field column is-5">
                            <label for="materias_id">Materia</label>
                            <div class="select">
                                <select class="select" name="materias_id" [ngClass]="{'is-danger': ctrl.dato.get('materias_id').hasError('required') }" formControlName="materias_id">
                                <option *ngFor="let item of materias;" value="{{item.id}}">Nivel: {{item.nivel}} / {{item.clave}} / {{item.nombre}}</option>
                              </select>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('materias_id').hasError('required') ">Este campo es requerido.</span>
                            </div>
                        </div>
                        <div class="field column is-2">
                            <span class="is-pulled-right">
                            <button type="button" class="button btn-lg is-success" (click)="agregar_form_array(ctrl.dato.controls.practicas_materias, form_practicas_materias)">
                              <i class="icon-add"></i> &nbsp;Agregar esta materia
                            </button>
                          </span>
                        </div>
                    </div>


                    <table class="table" style="width:100%;">
                        <thead>
                            <tr>
                                <th colspan="4" center>
                                    MATERIAS QUE AFECTA LA PRÁCTICA
                                </th>
                            </tr>
                            <tr>
                                <th>#</th>
                                <th>Nombre de materia</th>
                                <!-- <th>Porcentaje</th> -->
                                <th>Eliminar</th>
                            </tr>
                        </thead>
                        <tbody formArrayName="practicas_materias">
                            <tr *ngFor="let pm of ctrl.dato.controls.practicas_materias.controls; let i=index" [formGroupName]="i">
                                <td> {{ i + 1 }} </td>
                                <td>
                                    <div class="field">
                                        <p class="control has-icons-left has-icons-right">
                                            <input readonly class="input" formControlName="nombre" type="text" />
                                        </p>
                                    </div>
                                </td>
                                <!-- <td>
                              <div class="field">
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" title="Porcentaje " formControlName="porcentaje_valor" type="number" [ngClass]="{'is-danger': pm.get('porcentaje_valor').hasError('required')}"
                                  />

                                  <span class="icon is-small is-right" *ngIf="pm.get('porcentaje_valor').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="pm.get('porcentaje_valor').hasError('required') ">Este campo es requerido.</span>
                                </p>
                              </div>
                            </td> -->
                                <td>
                                    <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="quitar_form_array(ctrl.dato.controls.practicas_materias, i)">
                                <i class="icon-trash"></i>
                              </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </section>
            </form>
        </div>
    </div>
</div>